import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { Todo } from '../schema';
import { db } from '../instant';

interface Props {
    todo?: Todo;
    open: boolean;
    onClose: () => void;
}

export default function DeleteTodoDialog(props: Props) {
    const { user } = db.useAuth();

    if (!props.todo) {
        return <></>;
    }

    const deleteAndClose = async () => {
        if (props.todo) {
            const txs: any[] = [db.tx.todos[props.todo.id].delete()];

            if (props.todo.mapPin?.id && props.todo.todoType?.interactionType === 'place-new') {
                txs.push(db.tx.mapPins[props.todo.mapPin.id].delete());
            }

            await db.transact(txs);
            props.onClose();
        }
    };

    const todoTypeName = props.todo.todoType?.name || 'Task';
    const todoNotes = props.todo.notes || 'No notes';

    return (
        <Dialog open={props.open} onClose={props.onClose}>
            <DialogTitle>Really delete this todo?</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    The todo &quot;{todoTypeName}&quot; ({todoNotes}) will be deleted. This action cannot be undone.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose} autoFocus>
                    Cancel
                </Button>
                <Button disabled={!user} onClick={deleteAndClose} color="error">
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
}
